(() => {
  angular
    .module('finance')
    .controller(
      'finance.views.debugTools.updateNetSuiteBillingAccountsModal',
      UpdateNetSuiteBillingAccountsModalController
    );

  UpdateNetSuiteBillingAccountsModalController.$inject = [
    '$uibModalInstance',
    'abp.services.finance.debugTools',
  ];

  function UpdateNetSuiteBillingAccountsModalController(
    $uibModalInstance, 
    debugToolsSvc
  ) {
    const vm = this;
    
    vm.saving = 0;

    vm.updateNetSuiteBillingAccounts = updateNetSuiteBillingAccounts;
    vm.cancel = cancel;

    function updateNetSuiteBillingAccounts() {
      if (!App.isFormValid(vm.updateNetSuiteBillingAccountsForm)) return;

      vm.saving += 1;
      debugToolsSvc
        .updateNetSuiteBillingAccounts({
          maxCount: vm.maxCount,
          chunkSize: vm.chunkSize,
          delay: vm.delay,
          billingAccountId: vm.billingAccountId
        })
        .success(() => {
          abp.notify.success(App.localize('Queued'));
        })
        .finally(() => {
          $uibModalInstance.close();
        });
    }

    function cancel() {
      $uibModalInstance.dismiss();
    }
  }
})();
